export default __webpack_public_path__ + "static/imToken-d25e8f20a6dc47d4a14a98610c9e8dab.png";